import type { UseMutationResult } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';

import type {
  IApiAddAppUserRequestBody,
  IApiGetAppUserResponseBody,
} from '../AppsApi.types';
import { useApi } from '~/lib/api/useApi';
import { appUserQueryKeyFactory } from './useAppUserQuery';
import { appUsersQueryKeyFactory } from './useAppUsersQuery';

export type IUseAddAppUserMutationValues = {
  appId: string;
  body: IApiAddAppUserRequestBody;
};

export const useAddAppUserMutation = (): UseMutationResult<
  IApiGetAppUserResponseBody,
  unknown,
  IUseAddAppUserMutationValues
> => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (values) => api.apps.addUser(values.appId, values.body),
    onSuccess: async (updatedAppUser, values) => {
      queryClient.setQueryData(
        appUserQueryKeyFactory({
          ...values,
          userId: updatedAppUser._id,
        })!,
        updatedAppUser,
      );
      await queryClient.invalidateQueries({
        queryKey: appUsersQueryKeyFactory(values),
      });
    },
  });
};
